import { Config } from 'config';

export const MIN_PASSWORD_LENGTH = 9;
export const GET_LOGO_URL = (workspaceId: string) =>
    workspaceId ? `https://storage.googleapis.com/client-icons/${workspaceId}-2x.png` : '';

export const AUTH_API_URL = Config.get('AUTH_API_URL');
export const SOLAR_USER_APP_ID = 'solar-insights'; // temp value until we use auth0
export const SOLAR_USER_ROLE = 'solar-user'; // temp value until we use auth0
